module.exports = __webpack_public_path__ + "static/media/image-regular.9c27c61a.svg";